export const TENANT_HEADER = 'X-BRINGOZ-TENANT-ID';

export function resolveTenantId(win: Window = window): string | null {
  const domainParts = win.location.host.split('.');
  if (domainParts.length === 4) {
    return domainParts[0];
  }
  return win.localStorage.getItem(TENANT_HEADER);
}
